/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Notify,Dialog,Loading} from 'quasar'



export default { config: {"dark":false,"brand":{"primary":"#96593a","secondary":"#b89b5e","accent":"#7d5d42","dark":"#3d3732","dark-page":"#f2ede5","positive":"#4a7c59","negative":"#96593a","info":"#2b3a4e","warning":"#b89b5e"},"capacitor":{"iosStatusBarPadding":true,"backButtonExit":false}},plugins: {Notify,Dialog,Loading} }

